import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/services/erp-solution")({
  component: () => <Outlet />,
});
